import RESTClient from 'web-app/api/clients/rest-client-famly-app';

// Children
export const fetchVacations = childId =>
    RESTClient.getAuthenticatedObservable('v2/vacations', {childId, embedBehaviors: true});

export const fetchLeaveSummary = childId =>
    RESTClient.getAuthenticatedObservable(`v2/children/${childId}/leaves/summary`, {splitFuture: true}).map(
        response => ({
            leaveSummary: response,
        }),
    );

export const deleteLeavePeriodObservable = (childId, startDate, endDate) =>
    RESTClient.postAuthenticatedObservable('daycare/childleave/deleteperiod', {
        childId,
        startDate,
        endDate,
    });

export const deleteLeaveDay = childLeaveId =>
    RESTClient.deleteAuthenticatedObservable(`v2/childleaves/${childLeaveId}`);

// Employees
export const fetchEmployeeVacations = employeeId =>
    RESTClient.getAuthenticatedObservable('v2/vacations', {employeeId, embedBehaviors: true});

export const fetchEmployeeLeaveSummary = employeeId =>
    RESTClient.getAuthenticatedObservable(`v2/employees/${employeeId}/leaves/summary`, {
        splitFuture: true,
        includeBradfordFactor: true,
    }).map(response => {
        return {
            leaveSummary: response.summary,
            bradfordFactor: response.bradfordFactor,
        };
    });
